import { render, staticRenderFns } from "./AegPolicyFacts.vue?vue&type=template&id=0919e0d4"
import script from "./AegPolicyFacts.vue?vue&type=script&lang=js"
export * from "./AegPolicyFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports